import { createSlice } from '@reduxjs/toolkit';

type OptionsState = {
  sendEmail: boolean;
  windowFunction: string;
  windowSize: string;
};

const initialState: OptionsState = {
  sendEmail: true,
  windowFunction: 'first',
  windowSize: '1s',
};

const slice = createSlice({
  initialState,
  name: 'options',
  reducers: {
    setWindowFunction: (state, action) => {
      state.windowFunction = action.payload;
    },
    setWindowSize: (state, action) => {
      state.windowSize = action.payload;
    },
    toggleSendEmail: (state) => {
      state.sendEmail = !state.sendEmail;
    },
  },
});

const options = {
  reducer: slice.reducer,
  setWindowFunction: slice.actions.setWindowFunction,
  setWindowSize: slice.actions.setWindowSize,
  toggleSendEmail: slice.actions.toggleSendEmail,
};

export default options;
